export default __webpack_public_path__ + "static/media/MargotUndHans.9cda210a.png";